import React, { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '@containers/common/Footer';
import PageLoader from '@components/common/PageLoader';
import Notification from '@components/common/notification';
import withRouter from './withRouter';

const Header = withRouter(lazy(
  () => import('@containers/common/Header'),
));

const OnRouteChangeWithRouter = withRouter(lazy(
  () => import('@containers/common/OnRouteChange/index')
));

const LoadingComponent = ({ isLoading, isError }) => {
  if (isLoading) {
    return <PageLoader />;
  }
  if (isError) {
    return (
      <div>
        Sorry, unable to load the page
      </div>
    );
  }
  return null;
};

function RootLayout() {
  return (
    <>
      <div className="od-font-family od-color">
        <Suspense fallback={<LoadingComponent />}>
          <OnRouteChangeWithRouter>
            <Header />
            <Notification />
            <Outlet />
          </OnRouteChangeWithRouter>
        </Suspense>
        <Footer />
      </div>
    </>
  );
}

export default RootLayout;
